import styled from "styled-components";
import { MENU_WIDTH } from "components/theme";
import { DRAWER_MINI_WIDTH, DRAWER_WIDTH } from "layout/menuConfig";

export const WrapContent = styled.div`
    padding-top:64px;
    .os-wrapcontent{
        -webkit-transition: padding-left 0.2s ease-in;
        -moz-transition: padding-left 0.2s ease-in;
        -ms-transition: padding-left 0.2s ease-in;
        -o-transition: padding-left 0.2s ease-in;
        transition: padding-left 0.2s ease-in;
        min-height: calc(100vh - 64px);
    }

    .os-wrapcontent.with-menu {
        padding-left:${DRAWER_WIDTH}px;
    }
    .os-wrapcontent.with-menu.mini {
        padding-left:${DRAWER_MINI_WIDTH}px;
    }
    .os-wrapcontent.with-legacy-menu {
        padding-left:${MENU_WIDTH};
    }
    .os-wrapcontent.fullwidth{
        padding-left:0px;
    }

    .os-wrapcontent > form{
        display:block;
        height:100%;
    }
`;
